<template>
  <div class="mobile-footer">
    <div class="footer-info">
      <div class="left" v-show="lang === 'zh'">
        <p>厦门办公室：厦门市思明区领事馆路7号楼</p>
        <p>上海办公室：上海市溧阳路735号2幢3层</p>
        <p>福州办公室：福州市五四路128号恒力城12层</p>
        <p>电话：0591-87503376</p>
        <p>邮箱：contact@3lcapital.cn</p>
      </div>
      <div class="left" v-show="lang === 'en'">
        <p>Office: Building7,No.4 Consulate Road, Siming District, Xiamen, China</p>
        <p>Office: 3rd Floor, Building 2, No.735 Liyang Road, Hongkou District, Shanghai, China</p>
        <p>Office: 12th Floor, Hengli City, No.128 Wusi Road, Gulou District, Fuzhou, China</p>
        <p>Add：No. 7 Consulate Road, Siming District, Xiamen City, Fujian</p>
        <p>Tel：0591-87503376</p>
        <p>Email：contact@3lcapital.cn</p>
      </div>
      <div class="right">
        <div class="qrcode">
          <img src="../../assets/code.jpg" alt="">
        </div>
        <div class="desc">
          <p v-show="lang === 'zh'">
            <span class="txt-align">扫描二维码</span>
            <span class="txt-align">关注华闽联信</span>
          </p>
          <p v-show="lang === 'en'">
            <span class="txt-align">Scan & Follow Us</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileFooter",
  data() {
    return {
      show: false,
    }
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
  },
  methods: {
    onClick() {
      this.show = !this.show
    },

  }
}
</script>

<style scoped lang="less">
@import "../../common/theme.less";

.mobile-footer {
  padding: 1.333rem;
  color: white;
  background-color: #333345;
  background-image: url('../../assets/footer_bg_mobile.png');
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: auto 68%;
}

.footer-info {
  font-size: 1.16667rem;

  .left {
   // font-size: calc(@mobileFont * .28);
    width: 100%;
  }

  .right {
    margin-top: 12px;
    display: flex;
    align-items: center;

    .qrcode {
      flex-basis: 128px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .desc {
      flex: 1;
     // font-size: 1rem;
    }

    >* {
      vertical-align: middle;
    }

    p {
      display: inline-block;
      margin-right: calc(@mobileFont * .2);

      span {
        margin-left: 1rem;
        display: block;
      }
    }
  }
}

.fwcn {
  padding-top: calc(@mobileFont * .33);

  &-item {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #d2d2d2;

    .icon {
      width: calc(@mobileFont * 0.6);
      height: calc(@mobileFont * 0.6);
      margin-right: calc(@mobileFont * .3);
    }

    padding: calc(@mobileFont * .33) 0;

    &-right {
      .title {
        color: #037698;
        font-weight: bold;
      //  font-size: calc(@mobileFont * 0.28);
      }

      .desc {
        color: #666;
       // font-size: calc(@mobileFont * 0.22);
      }
    }
  }

  .head {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    color: #037698;
    font-weight: bold;
    cursor: pointer;
    font-size: calc(@mobileFont * 0.32);

    .arrow {
      margin-left: 4px;
      width: calc(@mobileFont * 0.28);
      height: calc(@mobileFont * 0.28);
      transform: rotate(0);
    }

    .transform90 {
      transform: rotate(-90deg);
    }
  }
}
</style>
